import { can } from 'services/can';
import { PermissionsMapping } from 'common/constants/role-intents';
import flags from 'containers/flags/service';

export function canEditFile(campaign) {
    if (!campaign) {
        return false;
    }
    if (campaign.isArchived && !flags.isEnabled('efb_201_campaign_expiry')) {
        return false;
    }

    return can(PermissionsMapping.CAMPAIGN__VIEW_AND_EDIT);
}
